import { IPreloadedState } from 'shared/types/redux';

export const selectSeoPageTitle = (state: IPreloadedState) => state.seoData.h1;
